<div class="stepper__component">
  @if (label) {
    <label class="kxi-label stepper__label">{{ label }}</label>
  }
  <div class="stepper__wrapper" [ngStyle]="{ 'height.px': height, 'width.px': width }">
    <div
      class="stepper__container"
      [class.stepper__container--edit]="isEditMode"
      [class.stepper__container--disabled]="disabled"
    >
      <xi-icon-button
        color="CX"
        type="button"
        [buttonSize]="size"
        icon="indeterminate"
        (onClick)="onValueChange('minus')"
        [disabled]="disabled"
      ></xi-icon-button>

      <app-inline-edit
        appEditOnEnter
        [control]="valueControl"
        (update)="onValueChange('inline')"
        (modeChange)="onModeChanged($event)"
        class="stepper__value-editor"
        [ngStyle]="{ 'font-size.px': fontSize, 'width.px': editorWidth }"
      >
        <ng-template appViewMode>
          <div
            class="stepper__value-editor--view"
            [class.stepper__value-editor--view--changed]="isChanged"
          >
            {{ innerValue | number: decimalsPipe }}
          </div>
        </ng-template>

        <ng-template appEditMode>
          <input
            [formControl]="valueControl"
            appNumericInput
            [allowNegative]="allowNegative"
            [allowFractional]="allowFractional"
            [decimals]="decimals"
            [minValue]="scale.min"
            [maxValue]="scale.max"
            appAutoFocus
            autoFocusTimeout="100"
            class="stepper__value-editor--edit"
          />
        </ng-template>
      </app-inline-edit>

      <xi-icon-button
        color="CX"
        type="button"
        [buttonSize]="size"
        icon="fab_plus"
        (onClick)="onValueChange('plus')"
        [disabled]="disabled"
      ></xi-icon-button>
    </div>
  </div>
</div>
